import { create } from 'zustand';
import { Brand, BrandTheme } from '../../modules/settings/brand/types/brand';
import { applyBrandTheme, DEFAULT_BRAND_THEME } from '../../modules/settings/brand/theme';
import { createJSONStorage, persist, StateStorage } from 'zustand/middleware';

type BrandState = {
  brand: Brand | null;
  theme: BrandTheme;
  hasLoaded: boolean;
  setBrand: (brand: Brand | null) => void;
  setTheme: (theme: BrandTheme) => void;
  setHasLoaded: (value: boolean) => void;
};

const noopStorage: StateStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
};

export const useBrandStore = create<BrandState>()(
  persist(
    set => ({
      brand: null,
      theme: DEFAULT_BRAND_THEME,
      hasLoaded: false,
      setBrand: brand => {
        const theme = applyBrandTheme(brand?.theme);
        set({
          brand,
          theme,
        });
      },
      setTheme: theme => {
        set({ theme: applyBrandTheme(theme) });
      },
      setHasLoaded: value => set({ hasLoaded: value }),
    }),
    {
      name: 'brand-store',
      // Rehydration restores `theme` but not the DOM attribute: re-apply it after a reload.
      onRehydrateStorage: () => state => {
        if (state) {
          applyBrandTheme(state.theme);
        }
      },
      storage: createJSONStorage(() =>
        typeof window !== 'undefined' ? window.localStorage : noopStorage,
      ),
    },
  ),
);
